// bookings/services/booking.api.js
import API from '../../../api/axios';

/**
 * Booking 主接口
 */
export const bookingApi = {
    async getMeta() {
        const { data } = await API.get('/booking/meta');
        return data;
    },

    async getById(id) {
        const { data } = await API.get(`/booking/${id}`);
        return data;
    },

    async create(payload) {
        const { data } = await API.post('/booking', payload);
        return data;
    },

    async update(id, payload) {
        const { data } = await API.patch(`/booking/${id}`, payload);
        return data;
    },

    // supplier actions
    async confirmBySupplier(id, payload = {}) {
        const { data } = await API.post(`/booking/${id}/supplier/confirm`, payload);
        return data;
    },

    async cancelBySupplier(id, payload) {
        const { data } = await API.post(`/booking/${id}/supplier/cancel`, payload);
        return data;
    },

    async proposeAlternativeBySupplier(id, payload) {
        const { data } = await API.post(
            `/booking/${id}/supplier/alternative`,
            payload
        );
        return data;
    },
};

/**
 * Pricing 相关接口
 */
export const pricingApi = {
    async preview(payload) {
        const { data } = await API.post('/booking/pricing/preview', payload);
        return data;
    },

    async previewExtras(payload, signal) {
        const { data } = await API.post('/booking/extras/preview', payload, { signal });
        return data;
    },
};

/**
 * Location 相关接口
 */
export const locationApi = {
    async getCountries() {
        const { data } = await API.get('/location/countries');
        return Array.isArray(data) ? data : (data?.data || []);
    },

    async getCities(countryId) {
        const { data } = await API.get(`/location/countries/${countryId}/cities`);
        return Array.isArray(data) ? data : (data?.data || []);
    },

    async getLocations(cityId) {
        const { data } = await API.get(`/location/cities/${cityId}/locations`);
        return Array.isArray(data) ? data : (data?.data || []);
    },
};

/**
 * Shop 相关接口
 */
export const shopApi = {
    async getByLocation(locationId) {
        const { data } = await API.get(`/shop/by-location/${locationId}`);
        const list = Array.isArray(data) ? data : (data?.data || []);
        return list.map((shop) => ({
            value: shop.id,
            label: `${shop.companyName} - ${shop.name}`,
        }));
    },

    async getById(shopId) {
        const { data } = await API.get(`/shop/${shopId}`);
        return data;
    },
};

/**
 * Motorcycle 相关接口
 */
export const motorcycleApi = {
    getShopMotorcycle: async (id) => {
        const { data } = await API.get(`/shop-motorcycles/item/${id}`);
        return data;
    },
};

/**
 * Currency 相关接口
 */
export const currencyApi = {
    async getAll() {
        const { data } = await API('/currencies');
        return data;
    },

    async getExchangeRate(from, to) {
        const { data } = await API.get(
            `/currencies/exchange?from=${encodeURIComponent(from)}&to=${encodeURIComponent(to)}`
        );
        return Number(data?.rate || 1);
    },
};